import { Note } from './assignmentsGeneral';
import { Chapter, Verse } from './books';
import { Assignment } from '@/types/projects';

export interface Task {
  id: number;
  bookId: number; // Currently not in backend
  chapterId: number; // In current backend it's chaptersId
  verseId: number; // In current backend it's versesId
}

export type TVerseStatusesValues = 1 | 2 | 3 | 4;
export type TVerseStatusesKeys = 'ASSIGNED' | 'COMPLETED';

export const TASK_STATUSES: Record<TVerseStatusesKeys, TVerseStatusesValues> = {
  ASSIGNED: 2,
  COMPLETED: 4,
} as const;

export type TAssignmentStatusesValues = 1 | 2 | 3 | 4;
export type TAssignmentStatusesKeys = 'LOCKED' | 'READY' | 'IN_PROGRESS' | 'COMPLETED';

export const ASSIGNMENT_STATUSES: Record<TAssignmentStatusesKeys, TAssignmentStatusesValues> = { // TODO: ACCORDION_STATUS could be replaced with this one.
  LOCKED: 1,
  READY: 2,
  IN_PROGRESS: 3,
  COMPLETED: 4,
};

export type TTaskTypesValues = 1 | 2 | 31 | 32 | 4;
export type TTaskTypesKeys = 'TRANSLATE' | 'PEER_REVIEW' | 'RATE' | 'TUAA' | 'PRONOUNS'; // TODO: Complete

// Almost all assignments have just one type of task, but others, like model assessment, have 2.
export const TASK_TYPES: Record<TTaskTypesKeys, TTaskTypesValues> = {
  TRANSLATE: 1,
  PEER_REVIEW: 2,
  RATE: 31,
  TUAA: 32,
  PRONOUNS: 4,
} as const;

export type TAssignmentTypeValues = 1 | 2 | 3 | 4 | 7;
export type TAssignmentTypeKeys = 'TRANSLATE' | 'PEER_REVIEW' | 'MODEL_ASSESSMENT' | 'PRONOUNS' | 'PEER_REVIEW_VERSE';

export const ASSIGNMENT_TYPES: Record<
  TAssignmentTypeKeys,
  TAssignmentTypeValues
> = {
  TRANSLATE: 1,
  PEER_REVIEW: 2,
  MODEL_ASSESSMENT: 3,
  PRONOUNS: 4,
  PEER_REVIEW_VERSE: 7,
} as const;

export interface WorkspaceTask extends Task {
  bookName: string; // Loading from getBooks endpoint would be more expensive, so it's easier to add it to each task
  chapterNumber: number; // Loading from getChapter endpoint would be too expensive, so it's easier to add it to each task
  verseNumber: number; // -- same here --
  verseText: string; // -- and here --
  status: TVerseStatusesValues; // FE only until we start saving
  isBookmarked?: boolean; // FE only until we start saving
  translation?: string;
  translatedSentenceId?: number;
  note?: string;
  isReviewCompleted?: boolean;
  hasError?: boolean;
  sentenceText?: string;
  editReviewerTranslation?: boolean;
}

export type WorkspaceAssignment = {
  id: number;
  books: {
    [bookId: number]: {
      id: number;
      chapters: {
        [chapterId: number]: {
          id: number;
          verses: {
            [verseId: number]: WorkspaceTask;
          };
        };
      };
    };
  };
};

export type WorkspaceAssignmentTemp = {
  targetCompletionDate?: Assignment['targetCompletionDate'];
};

export type WorkspaceAssignmentsPerProject = {
  [projectId: number]: {
    id: number;
    assignments: {
      [assignmentId: number]: WorkspaceAssignment;
    };
    // TODO:
    // this state slice is meant as temporary storage until the new api is in place and this store structure is stable.
    // it allows the ability to store `assignment` updates without the risk of being overwritten in the `assignments` slice above.
    assignmentsTemp: {
      [assignmentId: number]: WorkspaceAssignmentTemp;
    };
  };
};

export type VerseWithTask = Verse & { task?: WorkspaceTask };

export interface ChapterState extends Chapter {
  verses: VerseWithTask[];
  isCompleted: boolean;
}

export interface EditTask {
  translation?: string;
  note?: string;
  isBookmarked?: boolean;
  isReviewCompleted?: boolean;
  hasError?: boolean;
  sentenceText?: string;
  editReviewerTranslation?: boolean;
  translatedSentenceId?: number;
}

export interface AITranslationType {
  id: number;
  translation: string;
  translated_sentence_id: number;
  model_id: string;
}

export interface ModelSelectionTask {
  id: number;
  isCompleted: boolean;
  title: string;
  sourceText: string;
  bookId?: number;
  selectedAITranslationId?: number;
  aiTranslations: AITranslationType[];
  isBookmarked: boolean;
  notesList: Note[];
  taskDataId: number;
  taskTypeId: number;
  projectId: number;
  assignmentId: number;
}

export const ACCORDION_STATUS = {
  lock: 6,
  ready: 2,
  inProgress: 3,
  completed: 4,
};
